// CONTEXTS
import { OrderedPartsProvider } from "../../../contexts/parts/orderedParts.context";
// COMPONENTS
import LoggedIn from "../../../layouts/loggedIn.layout";
import OrderedPartsPage from "./page.orderedParts.page";

const OrderedPartsLayout = () => {
  return (
    <LoggedIn>
      <OrderedPartsProvider>
        <OrderedPartsPage />
      </OrderedPartsProvider>
    </LoggedIn>
  );
};

export default OrderedPartsLayout;
